import { useEffect, useState } from 'react';
import { getFeatureSummary } from '@/api/frontData.api';

let featureSummaryCache: BannerFeature[] | null = null;
let featureSummaryRequest: Promise<BannerFeature[]> | null = null;

const loadFeatureSummary = async () => {
  if (featureSummaryCache) {
    return featureSummaryCache;
  }

  if (!featureSummaryRequest) {
    featureSummaryRequest = getFeatureSummary()
      .then((response) => {
        featureSummaryCache = response.data;
        return response.data;
      })
      .catch((error) => {
        featureSummaryRequest = null;
        throw error;
      });
  }

  return featureSummaryRequest;
};

export const resetFeatureSummaryCacheForTests = () => {
  featureSummaryCache = null;
  featureSummaryRequest = null;
};

const useGetFeatures = () => {

  const [data, setData] = useState<BannerFeature[]>(featureSummaryCache ?? []);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const features = await loadFeatureSummary();
        if (mounted) {
          setData(features);
        }
      } catch (error) {
        console.log(error);
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, []);

  return data;
};

export default useGetFeatures;
